import { Store } from '../root';
import { IQuoteExtendedResponse } from '@joc/api-gateway/lib/api-client';

export const selectorGetQuotesAll = (store: Store): Array<IQuoteExtendedResponse> => store.quotesRedux.quotesRecords;
